import React from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';
import logoFindasense from '../assets/logo-findasense.png';
import logoFindasenseDark from '../assets/logo-findasense-dark.png';
import headerDecoration from '../assets/header-decoration.png';
import logoNivelics from '../assets/logo-nivelics.png';

const Header = ({ user, onLogout, onToggleDarkMode, darkMode }) => (
  <header className="header" style={{
    backgroundColor: darkMode ? '#434343' : '#FFFFE9',
    color: darkMode ? '#fff' : '#000',
    backgroundImage: `url(${headerDecoration})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
  }}>
    <nav className="nav">
      <div className="logo-container">
        <Link to="/">
          <img src={darkMode ? logoFindasenseDark : logoFindasense} alt="Logo" className="logo" />
        </Link>
      </div>
      <div className='menu' style={{ backgroundColor: darkMode ? 'rgba(15, 15, 15, 0)' : 'rgba(255, 255, 255, 0.8)', color: darkMode ? '#fff' : '#000' }}>
        <Link to="/" className="link">Inicio</Link>
        <Link to="/casos" className="link">Casos atendidos</Link>
        <Link to="/home" className="link">Asistente</Link>
        <button onClick={onToggleDarkMode} className="link button-link" style={{ marginRight: '15px' }}>
          {darkMode ? 'Modo Claro' : 'Modo Oscuro'}
        </button>
        {user ? (
          <button onClick={onLogout} className="link button-link">
            Cerrar sesión
          </button>
        ) : (
          <Link to="/login" className="link">Login</Link>
        )}
      </div>
    </nav>
  </header>
);

const Footer = ({ darkMode }) => (
  <footer className="footer" style={{ backgroundColor: darkMode ? '#434343' : '#434343', color: darkMode ? '#fff' : '#fff' }}>
    <nav className='nav footer-nav'>
      <div className="logo-container">
        <Link to="/">
          <img src={darkMode ? logoFindasenseDark : logoFindasenseDark} alt="Logo" className="logo" />
        </Link>
      </div>
      <Link to="/terminos" className="link">Términos y Condiciones</Link>
      <Link to="/politica" className="link">Política de Privacidad</Link>
      <Link to="/login" className="link">Reportar una falla</Link>
      <div className='logo-nivelics'>
        <span>Powered by</span>
        <a href="https://www.nivelics.com" target='_blank'>
          <img src={logoNivelics} alt="" />
        </a>
      </div>
    </nav>
    <p>&copy; {new Date().getFullYear()} FindAI. Todos los derechos reservados.</p>
  </footer>
);

const Layout = ({ user, onLogout, onToggleDarkMode, darkMode, children }) => (
  <>
    <Header user={user} onLogout={onLogout} onToggleDarkMode={onToggleDarkMode} darkMode={darkMode} />
    <main className={darkMode ? 'main dark' : 'main light'} style={{ backgroundColor: darkMode ? '#121212' : '#f5f5f5', color: darkMode ? '#e0e0e0' : '#000' }}>
      {children}
    </main>
    <Footer darkMode={darkMode} />
  </>
);

export default Layout;
